import styled from "styled-components";

export const Image = styled.img`
  cursor: pointer;
  width: 64px;

  @media screen and (max-width: 425px) {
    width: 32px;
  }
`;
